/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright (c) 2026 Steven Warehouse Project. All Rights Reserved.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
